module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_gps-61fe1bc0314a590f0a586cbcaecde4d7.svg";